import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export function appliedPromotionHasCouponCode(promotion) {
  return Boolean(promotion.couponCode);
}
export function associatePromotionsWithCoupons(_ref) {
  let {
    promotions,
    coupons
  } = _ref;

  if (!promotions || !coupons) {
    return promotions !== null && promotions !== void 0 ? promotions : [];
  }

  return promotions.map(promotion => {
    const coupon = coupons.find(coupon => coupon.campaignId === promotion.campaignId);
    return _objectSpread(_objectSpread({}, promotion), {}, {
      couponCode: coupon === null || coupon === void 0 ? void 0 : coupon.code
    });
  });
}
export function classifyAppliedPromotions(promotions) {
  if (!promotions) {
    return [[], []];
  }

  const couponBasedPromotions = promotions.filter(appliedPromotionHasCouponCode);
  const automaticPromotions = promotions.filter(promotion => !promotion.couponCode);
  return [couponBasedPromotions, automaticPromotions];
}